import React, { Component, MouseEvent, ReactNode } from 'react';
import { dispatch, RootState } from '../redux/store';
import { changeItemView, changeMetricIntervals } from '../redux/actions/PageActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import Icon from '../icons/Icon';
import ComponentName from '../constant/ComponentName';
import RoleHelper from '../RoleHelper';
import { AccessBase } from '../domain/access/BaseAccess';
import ComponentService from '../service/ComponentService';
import ServiceContainer from '../config/ServiceContainer';
import { ServiceNames } from '../constant/ServiceNames';
import moment from 'moment';
import { Dialog } from 'primereact/dialog';
import ComponentImportComponent from './ComponentImportComponent';
import {
  addGlobalWorkers,
  clearGlobalWorkers,
  ComponentState,
  ComponentWorker,
  removeGlobalWorkers,
  setSelectedItems,
} from '../redux/actions/ComponentActions';
import { query } from '@trlogic/client-js';
import CustomFilter from './custom/filter/CustomFilter';
import { customConfirm } from './custom/CustomPopupConfirm';
import LanguageUtil from '../util/LanguageUtil';
import { PageState } from '../redux/reducers/PageReducer';
import TableColumnPreferencesComponent from './TableColumnPreferencesComponent';
import { FormicaSelectBoxItem } from './custom/FormicaSearchSelectBox';
import _ from 'lodash';
import { CategoryState } from '../redux/reducers/CategoryReducer';
import ValueUtil from '../util/ValueUtil';
import { Tooltip } from 'primereact/tooltip';
import axios, { Canceler } from 'axios';
import IntervalManager from '../util/IntervalManager';
import { InstanceContainer } from '../config/binding/InstanceBinding';
import Injectables from '../constant/Injectables';
import CustomLoading from './custom/CustomLoading';
import BulkActionUtil, { BulkActionVisibility } from '../util/BulkActionUtil';
import Filter = query.Filter;

class ItemToolsMenuComponent extends Component<Props, State> {
  public state: State = new State();

  private componentService: ComponentService = ServiceContainer.getInstance().get(ServiceNames.COMPONENT);
  private intervalManager: IntervalManager = InstanceContainer.get(Injectables.INTERVAL_MANAGER);

  private countRequestStatus: boolean = false;
  private countRequestCanceler: Canceler | undefined;

  public render(): ReactNode {
    const {
      createFunc,
      exportVisible,
      acceptVisible,
      rejectVisible,
      actionVisible,
      importVisible: _importVisible,
      createVisible,
      component,
      _component,
      nextFunc,
      backFunc,
      itemsIsSelected,
      removeAllFunc,
      deployAllFunc,
      undeployAllFunc,
      acceptFunc,
      rejectFunc,
      actionFunc,
      chatFunc,
      customCreateName,
      id,
      onChangeFilter,
      componentLabel,
      componentId,
      exportVisibleAlways,
      defaultFilterDisabled,
      acceptLabel,
      rejectLabel,
      preferences,
      user,
      markFunc,
      markVisible,
      reportFunc,
      reportVisible,
      chatVisible,
      reportLoading,
      countVisible,
      customCounts,
      settingsFunc,
    } = this.props;
    const { importVisible, selectedColumns, count, bulkActionVisibility } = this.state;

    return (
      <div id={id} className={'flex flex-col gap-y-2 w-full pt-5 pb-4'}>
        <div className={'flex gap-x-1'}>
          <h5 className={'text-f-black-3  text-md 2xl:text-lg select-none flex items-center'}>{componentLabel}</h5>
          {count != undefined && countVisible !== false && (
            <>
              {count.total != undefined && (
                <div className={'total flex items-center cursor-pointer justify-center px-2 bg-[#F4F3FF] text-[#5925DC] h-[20px] min-w-[40px] rounded-xl'}>
                  {ValueUtil.numberShorten(count.total)}
                </div>
              )}
              {count.active != undefined && (
                <div className={'active flex items-center cursor-pointer justify-center px-2 bg-[#DDFBEA] text-[#027A48] h-[20px] min-w-[40px] rounded-xl'}>
                  {ValueUtil.numberShorten(count.active)}
                </div>
              )}
              {count.draft != undefined && (
                <div className={'draft flex items-center cursor-pointer justify-center px-2 bg-[#F4F3FF] text-[#5925DC] h-[20px] min-w-[40px] rounded-xl'}>
                  {ValueUtil.numberShorten(count.draft)}
                </div>
              )}
              {count.failed != undefined && (
                <div className={'failed flex items-center cursor-pointer justify-center px-2 bg-[#FFF1F3] text-[#D2332F] h-[20px] min-w-[40px] rounded-xl'}>
                  {ValueUtil.numberShorten(count.failed)}
                </div>
              )}
              {count.inReview != undefined && (
                <div className={'inReview flex items-center cursor-pointer justify-center px-2 bg-[#EFF8FF] text-[#175CD3] h-[20px] min-w-[40px] rounded-xl'}>
                  {ValueUtil.numberShorten(count.inReview)}
                </div>
              )}
              {count.waitingForReview != undefined && (
                <div
                  className={
                    'waitingForReview flex items-center cursor-pointer justify-center px-2 bg-[#F2F4F7] text-[#4F4F4F] h-[20px] min-w-[40px] rounded-xl'
                  }
                >
                  {ValueUtil.numberShorten(count.waitingForReview)}
                </div>
              )}
              <Tooltip target='.total'>{LanguageUtil.get({ id: 'components.itemToolsMenu.total', defaultMessage: 'Total' })}</Tooltip>
              <Tooltip target='.active'>
                {component == ComponentName.CASE || (component == ComponentName.ACH && componentId)
                  ? user.user.activeRiskType == 'fraud'
                    ? LanguageUtil.get({ id: 'components.itemToolsMenu.markedAsNotFraud', defaultMessage: 'Marked as not Fraud' })
                    : LanguageUtil.get({ id: 'components.itemToolsMenu.markedAsCompliant', defaultMessage: 'Marked as compliant' })
                  : component == ComponentName.WATCHLIST_ALERT
                    ? LanguageUtil.get({ id: 'components.itemToolsMenu.markedNotMatched', defaultMessage: 'Marked as not Matched' })
                    : LanguageUtil.get({ id: 'components.itemToolsMenu.activeS', defaultMessage: 'Active' })}
              </Tooltip>
              <Tooltip target='.draft'>{LanguageUtil.get({ id: 'components.itemToolsMenu.draftS', defaultMessage: 'Draft' })}</Tooltip>
              <Tooltip target='.failed'>
                {component == ComponentName.CASE || (component == ComponentName.ACH && componentId)
                  ? user.user.activeRiskType == 'fraud'
                    ? LanguageUtil.get({ id: 'components.itemToolsMenu.markedAsFraud', defaultMessage: 'Marked as fraud' })
                    : LanguageUtil.get({ id: 'components.itemToolsMenu.markedAsInCompliant', defaultMessage: 'Marked as in compliant' })
                  : component == ComponentName.WATCHLIST_ALERT
                    ? LanguageUtil.get({ id: 'components.itemToolsMenu.markedMatched', defaultMessage: 'Marked Matched' })
                    : LanguageUtil.get({ id: 'components.itemToolsMenu.failedS', defaultMessage: 'Failed' })}
              </Tooltip>
              <Tooltip target='.inReview'>{LanguageUtil.get({ id: 'components.itemToolsMenu.inReview', defaultMessage: 'In Review' })}</Tooltip>
              <Tooltip target='.waitingForReview'>
                {LanguageUtil.get({ id: 'components.itemToolsMenu.waitingForReview', defaultMessage: 'Waiting For Review' })}
              </Tooltip>
            </>
          )}
          {customCounts?.map((customCount) => (
            <React.Fragment key={customCount.key}>
              <div
                className={`custom-count-${customCount.key} flex items-center cursor-pointer justify-center px-2 h-[20px] min-w-[40px] rounded-xl ${customCount.className}`}
              >
                {ValueUtil.numberShorten(customCount.value)}
              </div>
              <Tooltip target={`.custom-count-${customCount.key}`}>{customCount.label}</Tooltip>
            </React.Fragment>
          ))}
        </div>
        <div className={'flex w-full justify-between'}>
          <div className={'w-5/6'}>
            {onChangeFilter && (
              <CustomFilter
                key={componentId}
                componentName={component}
                componentId={componentId}
                onChange={onChangeFilter}
                defaultFilterDisabled={defaultFilterDisabled}
              />
            )}
          </div>
          <div className={'flex justify-end gap-x-1 self-center w-1/6'}>
            {createFunc && (createVisible ?? true) && !itemsIsSelected && this.canEdit() && (
              <a
                data-testid={`${component}_create_button`}
                className='cursor-pointer relative group border rounded border-[#E0E4E8] w-[28px] h-[28px] flex items-center justify-center bg-white-1 hover:bg-f-gray active:bg-[#458EF714] active:border-[#458EF7]'
                onClick={(e) => createFunc(e)}
              >
                <Icon icon={'add'} size={18} color={'#4F4F4F'} className={'group-hover:text-primary hover:cursor-pointer flex items-center justify-center'} />
                <div className={'z-50 -bottom-5 rounded absolute hidden px-[10px] py-[2px] text-2xs text-white bg-primary group-hover:flex'}>
                  {customCreateName || LanguageUtil.get({ id: 'components.itemToolsMenu.create', defaultMessage: 'Create' })}
                </div>
              </a>
            )}
            {removeAllFunc && itemsIsSelected && this.canEdit() && bulkActionVisibility.showRemove && (
              <a
                data-testid={`${component}_remove_all_button`}
                className='cursor-pointer relative group border rounded border-[#E0E4E8] w-[28px] h-[28px] flex items-center justify-center bg-white-1 hover:bg-f-gray active:bg-[#458EF714] active:border-[#458EF7]'
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  customConfirm({
                    target: e.currentTarget,
                    accept: () => this.removeAll(e),
                    message: LanguageUtil.get({ id: 'messages.confirm.confirmRemove', defaultMessage: 'Are you sure you want to remove?' }),
                  });
                }}
              >
                <Icon icon={'delete'} size={18} color={'#4F4F4F'} className={'hover:text-primary hover:cursor-pointer flex items-center justify-center'} />
                <div
                  className={'z-50 -bottom-8 rounded absolute hidden w-16  items-center justify-center py-1 text-2xs text-white bg-primary group-hover:flex'}
                >
                  {LanguageUtil.get({ id: 'components.itemToolsMenu.removeAll', defaultMessage: 'Remove All' })}
                </div>
              </a>
            )}
            {deployAllFunc && itemsIsSelected && this.canEdit() && bulkActionVisibility.showDeploy && (
              <a
                data-testid={`${component}_deploy_all_button`}
                className='cursor-pointer relative group border rounded border-[#E0E4E8] w-[28px] h-[28px] flex items-center justify-center bg-white-1 hover:bg-f-gray active:bg-[#458EF714] active:border-[#458EF7]'
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  customConfirm({
                    target: e.currentTarget,
                    accept: () => this.deployAll(e),
                    message: LanguageUtil.get({ id: 'messages.confirm.deploy1', defaultMessage: 'Are you sure you want to deploy?' }),
                  });
                }}
              >
                <Icon icon={'deploy'} size={18} color={'#4F4F4F'} className={'hover:text-primary hover:cursor-pointer flex items-center justify-center'} />
                <div
                  className={'z-50 -bottom-8 rounded absolute hidden w-16  items-center justify-center py-1 text-2xs text-white bg-primary group-hover:flex'}
                >
                  {LanguageUtil.get({ id: 'components.itemToolsMenu.deployAll', defaultMessage: 'Deploy All' })}
                </div>
              </a>
            )}
            {undeployAllFunc && itemsIsSelected && this.canEdit() && bulkActionVisibility.showUndeploy && (
              <a
                data-testid={`${component}_undeploy_all_button`}
                className='cursor-pointer relative group border rounded border-[#E0E4E8] w-[28px] h-[28px] flex items-center justify-center bg-white-1 hover:bg-f-gray active:bg-[#458EF714] active:border-[#458EF7]'
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  customConfirm({
                    target: e.currentTarget,
                    accept: async () => this.undeployAll(e),
                    message: LanguageUtil.get({ id: 'messages.confirm.undeploy1', defaultMessage: 'Are you sure you want to undeploy?' }),
                  });
                }}
              >
                <Icon icon={'undeploy'} size={18} color={'#4F4F4F'} className={'hover:text-primary hover:cursor-pointer flex items-center justify-center'} />
                <div
                  className={'z-50 -bottom-8 rounded absolute hidden text-2xs w-[5rem] items-center justify-center py-1 text-white bg-primary group-hover:flex'}
                >
                  {LanguageUtil.get({ id: 'components.itemToolsMenu.undeployAll', defaultMessage: 'Undeploy All' })}
                </div>
              </a>
            )}
            {reportFunc && (reportVisible ?? true) && (
              <a
                data-testid={`${component}_report_button`}
                className='cursor-pointer relative group border rounded border-[#E0E4E8] min-w-[28px] h-[28px] flex items-center justify-center bg-white-1 hover:bg-f-gray active:bg-[#458EF714] active:border-[#458EF7]'
                onClick={reportFunc}
              >
                {reportLoading ? (
                  <div className={'w-[16px] h-[16px]'}>
                    <CustomLoading />
                  </div>
                ) : (
                  <Icon icon={'sar-icon'} size={14} color={'#4F4F4F'} className={'hover:text-primary hover:cursor-pointer flex items-center justify-center'} />
                )}
                <div className={'z-50 -bottom-5 rounded absolute hidden px-[10px] py-[2px] text-2xs text-white bg-primary group-hover:flex'}>
                  {LanguageUtil.get({ id: 'components.itemToolsMenu.sar', defaultMessage: 'SAR' })}
                </div>
              </a>
            )}
            {chatFunc && (chatVisible ?? true) && (
              <a
                data-testid={`${component}_chat_button`}
                className='cursor-pointer relative group border rounded border-[#E0E4E8] min-w-[28px] h-[28px] flex items-center justify-center bg-white-1 hover:bg-f-gray active:bg-[#458EF714] active:border-[#458EF7]'
                onClick={chatFunc}
              >
                <Icon icon={'comment'} size={18} color={'#4F4F4F'} className={'hover:text-primary hover:cursor-pointer flex items-center justify-center'} />
                <div className={'z-50 -bottom-5 rounded absolute hidden px-[10px] py-[2px] text-2xs text-white bg-primary group-hover:flex'}>
                  {LanguageUtil.get({ id: 'components.itemToolsMenu.chat', defaultMessage: 'Chat' })}
                </div>
              </a>
            )}
            {markFunc && (markVisible ?? true) && (
              <a
                data-testid={`${component}_mark_button`}
                className='cursor-pointer relative group border rounded border-[#E0E4E8] min-w-[28px] min-h-[28px] flex items-center justify-center bg-white-1 hover:bg-f-gray active:bg-[#458EF714] active:border-[#458EF7]'
                onClick={(e) => markFunc()}
              >
                <Icon
                  icon={'marktransactions'}
                  size={18}
                  color={'#4F4F4F'}
                  className={'group-hover:text-primary hover:cursor-pointer flex items-center justify-center'}
                />
                <div className={'z-50 -bottom-5 rounded absolute hidden px-[10px] py-[2px] text-2xs text-white bg-primary group-hover:flex'}>
                  {LanguageUtil.get({ id: 'components.itemToolsMenu.markTransactions', defaultMessage: 'Mark Transactions' })}
                </div>
              </a>
            )}
            {preferences?.columnPreferencesVisible && (
              <TableColumnPreferencesComponent
                items={preferences?.columns ?? []}
                onChangeSelectedItems={(columns) => this.setState({ selectedColumns: columns ?? [] })}
                selectedItems={selectedColumns}
                apply={() => {
                  preferences?.onChangeColumnPreferences?.(selectedColumns);
                }}
              />
            )}
            {(_importVisible == undefined ? true : _importVisible) && !itemsIsSelected && this.canEdit() && (
              <a
                data-testid={`${component}_import_button`}
                className='cursor-pointer relative group border rounded border-[#E0E4E8] w-[28px] h-[28px] flex items-center justify-center bg-white-1 hover:bg-f-gray active:bg-[#458EF714] active:border-[#458EF7]'
                onClick={() => this.importFunc()}
              >
                <Icon icon={'import'} size={18} color={'#4F4F4F'} className={'hover:text-primary hover:cursor-pointer flex items-center justify-center'} />
                <div className={'z-50 -bottom-5 rounded absolute hidden px-[10px] py-[2px] text-2xs text-white bg-primary group-hover:flex'}>
                  {LanguageUtil.get({ id: 'components.itemToolsMenu.import', defaultMessage: 'Import' })}
                </div>
              </a>
            )}
            {(exportVisible == undefined ? true : exportVisible) &&
              (exportVisibleAlways || (_component.selectedComponentIds && _component.selectedComponentIds.length > 0)) && (
                <a
                  data-testid={`${component}_export_button`}
                  className='cursor-pointer relative group border rounded border-[#E0E4E8] min-w-[28px] h-[28px] flex items-center justify-center bg-white-1 hover:bg-f-gray active:bg-[#458EF714] active:border-[#458EF7]'
                  onClick={() => this.exportFunc()}
                >
                  <Icon icon={'export'} size={18} color={'#4F4F4F'} className={'hover:text-primary hover:cursor-pointer flex items-center justify-center'} />
                  <div className={'z-50 -bottom-5 rounded absolute hidden px-[10px] py-[2px] text-2xs text-white bg-primary group-hover:flex'}>
                    {LanguageUtil.get({ id: 'components.itemToolsMenu.export', defaultMessage: 'Export' })}
                  </div>
                </a>
              )}
            {settingsFunc && (
              <a
                data-testid={`${component}_settings_button`}
                className='cursor-pointer relative group border rounded border-[#E0E4E8] min-w-[28px] h-[28px] flex items-center justify-center bg-white-1 hover:bg-f-gray active:bg-[#458EF714] active:border-[#458EF7]'
                onClick={() => settingsFunc()}
              >
                <Icon icon={'settings'} size={18} color={'#4F4F4F'} className={'hover:text-primary hover:cursor-pointer flex items-center justify-center'} />
                <div className={'z-50 -bottom-5 rounded absolute hidden px-[10px] py-[2px] text-2xs text-white bg-primary group-hover:flex'}>
                  {LanguageUtil.get({ id: 'components.itemToolsMenu.settings', defaultMessage: 'Settings' })}
                </div>
              </a>
            )}
            {backFunc && (
              <a
                data-testid={`${component}_back_button`}
                className='cursor-pointer relative group border rounded border-[#E0E4E8] w-[28px] h-[28px] flex items-center justify-center bg-white-1 hover:bg-f-gray active:bg-[#458EF714] active:border-[#458EF7]'
                onClick={() => backFunc()}
              >
                <Icon icon={'arrow-left'} size={20} color={'#4F4F4F'} className={'hover:text-primary hover:cursor-pointer flex items-center justify-center'} />
                <div className={'z-50 -bottom-5 rounded absolute hidden px-[10px] py-[2px] text-2xs text-white bg-primary group-hover:flex'}>
                  {LanguageUtil.get({ id: 'components.itemToolsMenu.back', defaultMessage: 'Back' })}
                </div>
              </a>
            )}
            {nextFunc && (
              <a
                data-testid={`${component}_next_button`}
                className='cursor-pointer relative group border rounded border-[#E0E4E8] w-[28px] h-[28px] flex items-center justify-center bg-white-1 hover:bg-f-gray active:bg-[#458EF714] active:border-[#458EF7]'
                onClick={() => nextFunc()}
              >
                <Icon icon={'arrow-right'} size={22} className={'hover:text-primary hover:cursor-pointer flex items-center justify-center'} />
                <div className={'z-50 -bottom-5 rounded absolute hidden px-[10px] py-[2px] text-2xs text-white bg-primary group-hover:flex'}>
                  {LanguageUtil.get({ id: 'components.itemToolsMenu.next', defaultMessage: 'Next' })}
                </div>
              </a>
            )}
            {(actionVisible == undefined ? true : actionVisible) && actionFunc && (
              <a
                data-testid={`${component}_action_button`}
                className='cursor-pointer relative group border rounded border-[#E0E4E8] min-w-[28px] h-[28px] flex items-center justify-center bg-white-1 hover:bg-f-gray active:bg-[#458EF714] active:border-[#458EF7]'
                onClick={(e) => actionFunc(e)}
              >
                <Icon
                  icon={'sidebar-action'}
                  size={14}
                  color={'#4F4F4F'}
                  className={'hover:text-primary hover:cursor-pointer flex items-center justify-center'}
                />
                <div className={'z-50 -bottom-5 rounded absolute hidden px-[10px] py-[2px] text-2xs text-white bg-primary group-hover:flex'}>
                  {LanguageUtil.get({ id: 'components.itemToolsMenu.action', defaultMessage: 'Action' })}
                </div>
              </a>
            )}
            {(acceptVisible == undefined ? true : acceptVisible) && acceptFunc && (
              <a
                data-testid={`${component}_accept_button`}
                className='cursor-pointer relative group border rounded border-[#E0E4E8] w-[28px] h-[28px] flex items-center justify-center bg-white-1 hover:bg-f-gray active:bg-[#458EF714] active:border-[#458EF7]'
                onClick={(e) => acceptFunc(e)}
              >
                <Icon icon={'t-approved'} size={26} color={'#027A48'} className={'hover:text-primary hover:cursor-pointer flex items-center justify-center'} />
                <div className={'z-50 -bottom-5 rounded absolute hidden px-[10px] py-[2px] text-2xs text-white bg-primary group-hover:flex'}>
                  {acceptLabel ? acceptLabel : LanguageUtil.get({ id: 'components.itemToolsMenu.approve', defaultMessage: 'Approve' })}
                </div>
              </a>
            )}
            {(rejectVisible == undefined ? true : rejectVisible) && rejectFunc && (
              <a
                data-testid={`${component}_reject_button`}
                className='cursor-pointer relative group border rounded border-[#E0E4E8] w-[28px] h-[28px] flex items-center justify-center bg-white-1 hover:bg-f-gray active:bg-[#458EF714] active:border-[#458EF7]'
                onClick={(e) => rejectFunc(e)}
              >
                <Icon icon={'t-declined'} size={26} color={'#D2332F'} className={'hover:text-primary hover:cursor-pointer flex items-center justify-center'} />
                <div className={'z-50 -bottom-5 rounded absolute hidden px-[10px] py-[2px] text-2xs text-white bg-primary group-hover:flex'}>
                  {rejectLabel ? rejectLabel : LanguageUtil.get({ id: 'components.itemToolsMenu.decline', defaultMessage: 'Decline' })}
                </div>
              </a>
            )}
            {component && (
              <Dialog className={'min-w-[50vh] min-h-[50vh]'} visible={importVisible} onHide={this.closeImportPanel} dismissableMask closable closeOnEscape>
                <ComponentImportComponent component={component} close={this.closeImportPanel} />
              </Dialog>
            )}
          </div>
        </div>
      </div>
    );
  }

  public async componentDidMount() {
    const { sessionCheck, component, preferences, addGlobalWorkers, removeGlobalWorkers, clearGlobalWorkers, componentId, totalCount, items } = this.props;
    this.intervalManager.clearMetricIntervals();
    if (totalCount != undefined) {
      this.setState({ count: { total: totalCount } });
    } else if (items != undefined) {
      this.setState({
        count: {
          total: items.length,
          active: items.filter((item) => item.stage == 'ACTIVE').length,
          draft: items.filter((item) => item.stage == 'DRAFT').length,
          failed: items.filter((item) => item.stage == 'FAILED').length,
        },
      });
    }
    if (sessionCheck && component) {
      clearGlobalWorkers();
      setTimeout(() => {
        this.componentService.listenAllLock(component, (worker: ComponentWorker | null, componentId: string) => {
          if (worker) {
            addGlobalWorkers({ worker, componentId, component });
          } else {
            removeGlobalWorkers({ componentId, component });
          }
        });
      }, 1000);
    }
    if (this.props.component == ComponentName.WATCHLIST_ALERT || this.props.component == ComponentName.CASE || this.props.component == ComponentName.ACH) {
      await this.calculateMetric();
      this.intervalManager.addMetricInterval(
        setInterval(async () => {
          await this.calculateMetric();
        }, 5_000) as any,
      );
    }
    if (component) {
      const bulkActionVisibility = BulkActionUtil.getBulkActionVisibility(
        (this.props._component.selectedComponentIds as AccessBase[]) || [],
        component,
      );
      this.setState({
        selectedColumns: preferences?.selectedColumns ?? preferences?.columns ?? [],
        bulkActionVisibility,
      });
      return;
    }
    this.setState({ selectedColumns: preferences?.selectedColumns ?? preferences?.columns ?? [] });
  }

  public async componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
    const { items, componentId, filter, component, _component, totalCount } = this.props;
    if (!_.isEqual(prevProps.preferences?.columns, this.props.preferences?.columns)) {
      this.setState({ selectedColumns: this.props.preferences?.selectedColumns ?? this.props.preferences?.columns ?? [] });
    }
    if (prevProps.componentId != componentId) {
      this.calculateMetric();
    }
    if (prevProps.filter != filter) {
      this.calculateMetric();
    }
    if (prevProps.totalCount !== totalCount && totalCount != undefined) {
      this.setState({ count: { total: totalCount } });
    } else if (prevProps.items != items && totalCount == undefined) {
      const count = {
        total: items?.length,
        active: items?.filter((item) => item.stage == 'ACTIVE').length,
        draft: items?.filter((item) => item.stage == 'DRAFT').length,
        failed: items?.filter((item) => item.stage == 'FAILED').length,
      };
      this.setState({ count });
    }
    if (prevProps._component.selectedComponentIds !== _component.selectedComponentIds && component) {
      const bulkActionVisibility = BulkActionUtil.getBulkActionVisibility(_component.selectedComponentIds as AccessBase[], component);
      this.setState({ bulkActionVisibility });
    }
  }

  public componentWillUnmount = async () => {
    this.intervalManager.clearMetricIntervals();
    this.countRequestCanceler?.();
  };

  private canEdit = () => {
    const { component } = this.props;
    if (component == undefined) return true;
    return RoleHelper.canEdit(component);
  };

  private exportFunc = async () => {
    const { _component, component, exportFunc, page } = this.props;
    if (exportFunc) {
      exportFunc();
      return;
    }
    if (component == undefined) return;
    const currentCategory = page.currentCategory?.id;
    const selected: string[] = (_component.selectedComponentIds as AccessBase[]).flatMap((i) => i.id).filter((i) => i != undefined) as string[];
    const data: AccessBase[] = await this.componentService.export(component, selected, currentCategory);
    if (data.length == 0) return;
    const aElement = document.createElement('a');
    const blob = new Blob([JSON.stringify(data)], { type: 'application/json' });
    aElement.href = URL.createObjectURL(blob);
    aElement.download = `${component}_${moment().valueOf()}.json`;
    aElement.click();
    aElement.remove();
  };

  private closeImportPanel = () => {
    this.setState({ importVisible: false });
  };

  private importFunc = () => {
    const { importFunc } = this.props;
    if (importFunc) {
      importFunc();
      return;
    }
    this.setState({ importVisible: true });
  };

  private removeAll = (e: MouseEvent) => {
    const { removeAllFunc } = this.props;
    removeAllFunc?.(e);
  };

  private deployAll = (e: MouseEvent) => {
    const { deployAllFunc } = this.props;
    deployAllFunc?.(e);
  };

  private undeployAll = (e: MouseEvent) => {
    const { undeployAllFunc } = this.props;
    undeployAllFunc?.(e);
  };

  private calculateMetric = async () => {
    const { component, componentId, filter } = this.props;
    if (this.countRequestStatus) return;
    const excluded = [
      ComponentName.STRUCT,
      ComponentName.CONFIGURATION,
      ComponentName.ADMIN,
      ComponentName.ADMIN_USER,
      ComponentName.ADMIN_ROLE,
      ComponentName.ADMIN_GROUP,
      ComponentName.ADMIN_AUDIT_LOG,
      ComponentName.LOGIN_AUDIT_LOG,
      ComponentName.COMPONENT_AUDIT_LOG,
      ComponentName.ASSESSMENT,
      ComponentName.POLICY,
      ComponentName.CUSTOM_LIST,
    ];
    if (component && !excluded.includes(component)) {
      try {
        this.countRequestCanceler?.();
        const token = axios.CancelToken.source();
        this.countRequestCanceler = token.cancel;
        this.countRequestStatus = true;
        const count = await this.componentService.count(component, componentId, token.token, filter);
        this.setState({ count });
      } catch (e) {
      } finally {
        this.countRequestStatus = false;
      }
    }
  };
}

interface Props extends ReduxProps {
  createFunc?(e: any): void;
  removeAllFunc?(e: any): void;
  deployAllFunc?(e: any): void;
  undeployAllFunc?(e: any): void;
  acceptFunc?(e: any): void;
  rejectFunc?(e: any): void;
  actionFunc?(e: any): void;

  component?: ComponentName;
  importFunc?: VoidFunction;
  exportFunc?: VoidFunction;
  filterFunc?: (e: MouseEvent) => void;
  backFunc?: VoidFunction;
  nextFunc?: VoidFunction;
  markFunc?: VoidFunction;
  reportFunc?: VoidFunction;
  chatFunc?: VoidFunction;
  markVisible?: boolean;
  createVisible?: boolean;
  exportVisible?: boolean;
  exportVisibleAlways?: boolean;
  importVisible?: boolean;
  acceptVisible?: boolean;
  rejectVisible?: boolean;
  reportVisible?: boolean;
  chatVisible?: boolean;
  actionVisible?: boolean;
  reportLoading?: boolean;
  views?: boolean;
  itemsIsSelected?: boolean;
  customCreateName?: string;
  id?: string;
  componentLabel?: string;
  onChangeFilter?: (filter: Filter) => void;
  componentId?: string;
  defaultFilterDisabled?: boolean;
  acceptLabel?: string;
  rejectLabel?: string;
  sessionCheck?: boolean;
  preferences?: ItemToolsMenuTablePreferenceProps;
  items?: any[];
  filter?: Filter;
  countVisible?: boolean;
  totalCount?: number;
  customCounts?: ItemToolsMenuCustomCount[];
  settingsFunc?: VoidFunction;
}

export interface ItemToolsMenuCustomCount {
  key: string;
  label: string;
  value: number;
  className: string;
}

export interface ItemToolsMenuTablePreferenceProps {
  onChangeColumnPreferences?(selectedColumns: FormicaSelectBoxItem[]): void;

  columnPreferencesVisible?: boolean;
  columns?: FormicaSelectBoxItem[];
  selectedColumns?: FormicaSelectBoxItem[];
}

class State {
  importVisible: boolean = false;
  selectedColumns: FormicaSelectBoxItem[] = [];
  count: { total?: number; active?: number; draft?: number; failed?: number; inReview?: number; waitingForReview?: number } | undefined;
  bulkActionVisibility: BulkActionVisibility = { showDeploy: false, showUndeploy: false, showRemove: false };
}

const mapStateToProps = (state: RootState) => ({
  itemView: state.page.itemView,
  user: state.auth,
  page: state.page as PageState,
  _component: state.component as ComponentState,
  category: state.category as CategoryState,
});
const mapDispatchToProps = { changeItemView, addGlobalWorkers, removeGlobalWorkers, clearGlobalWorkers, changeMetricIntervals };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(ItemToolsMenuComponent);
